import React, { useState, useEffect, useCallback, useMemo } from "react";
import Joyride, { Step, ACTIONS, EVENTS, CallBackProps } from 'react-joyride';

import { Config } from "@eagerdog/config";
import { Constants } from "@eagerdog/constants";
import { IAddress } from "@eagerdog/interfaces";
import moment from "moment";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions, Stripe } from '@stripe/stripe-js';
import { Helmet } from "react-helmet";
import { isPossiblePhoneNumber } from 'react-phone-number-input';

import { apiService } from "../../services";
import { helperService } from "../../services/helper.service";
import { IShow, IDog, IDogClass, EventDogShowsDto, ITransactionPaymentSummary, IUser, IShowElement, EventRegistrationCreateDto } from "@eagerdog/interfaces";

import ShowTime from "./ShowTime/ShowTime";
import Checkout from "./Checkout/Checkout";
import UserAddress, { isValidAddress, isValidPhone, IAddressError } from "./UserAddress/UserAddress";

import Input from "src/components/Input/Input";
import Phone from "src/components/Phone/Phone";
import Dropdown, { IOption } from "src/components/Dropdown/Dropdown";
import Button from "src/components/Button/Button";
import Cart from "src/components/Cart/Cart";
import DogForm from "src/components/StepForm/DogForm/DogForm";
import FormBuilder from "src/components/FormBuilder/FormBuilder";
import Checkbox from "src/components/Checkbox/Checkbox";
import { Modal, useModal } from "src/components/Modal/Modal";
import DogPortrait from "src/components/DogPortrait/DogPortrait";
import Confirm from "src/components/Confirm/Confirm";
//import RadioList, { IRadioListItem } from "src/components/RadioList/RadioList";
import { workingOrCourierOptions, getWorkingLegOptions } from "./utils/WaterDog"

import { toast } from "src/components/Toast/ToastManager";

import emailIcon from "src/assets/icons/email.svg";
import "./EventRegister.scss";

interface IProps {}

export interface IDogInfo extends IDog {
  start_minutes?: number,
  time_slot?: string,
  classes?: IDogClass[],
  plan_to_earn_title?: boolean,
  title?: string,
  using_agent?: boolean,
  agent_name?: string,
  agent_number?: string,
  using_non_agent?: boolean,
  agent_phone?: string,
  agent_email?: string,

  substitute_name?: string,
  substitute_email?: string,
  substitute_phone?: string,

  leg_info?: string,

  splashes?: number
}

export interface IShowDogs extends IShow {
  dogs: IDogInfo[],
  registered_dogs?: number,
  created_by?: string,
  club_id: string
}

type AgentPayload = {
  name?: string
  email?: string
  phone?: string
  number?: string
}

type SubstitutePayload = {
  name?: string
  email?: string
  phone?: string
}

const EventRegister: React.FC<IProps> = (props) => {
  const navigate = useNavigate();

  let { eid } = useParams();
  let { isShown, toggle } = useModal();

  const user:IUser = helperService.getUser();

  const steps:string[] = ["Select Dogs", "Dog Details", "Sanctioning Club Waiver", "Event Waiver", "Payment"];

  const [joyrideSteps, setJoyrideSteps] = useState<Step[]>([]);
  const [joyrideRun, setJoyrideRun] = useState<boolean>(false);
  const [joyrideStepIndex, setJoyrideStepIndex] = useState<number>(0);

  const [onBehalf, setOnBehalf] = useState<string>();
  const [onBehalfEmail, setOnBehalfEmail] = useState<string>();
  const [onBehalfJunior, setOnBehalfJunior] = useState<string>();
  const [isClaimed, setIsClaimed] = useState<boolean>(false);

  const [loadingBehalf, setLoadingBehalf] = useState<boolean>(false);

  const [currentStep, setCurrentStep] = useState<number>(0);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [shows, setShows] = useState<IShowDogs[]>([]);
  const [event, setEvent] = useState<any>();
  const [currentShow, setCurrentShow] = useState<number>(-1);
  const [currentShowTime, setCurrentShowTime] = useState<number>(0);
  const [showTypes, setShowTypes] = useState<string[]>([]);
  const [dogs, setDogs] = useState<IDog[]>([]);
  const [agreeToWaiver, setAgreeToWaiver] = useState<boolean>(false);
  const [agreeToEventWaiver, setAgreeToEventWaiver] = useState<boolean>(false);
  const [regPayload, setRegPayload] = useState<EventDogShowsDto[]>();

  const [stripePromise, setStripePromise] = useState<Promise<Stripe | null>>();
  const [stripeOptions, setStripeOptions] = useState<StripeElementsOptions>();

  const [paymentIntentId, setPaymentIntentId] = useState<string>();
  const [transactionId, setTransactionId] = useState<string>();

  const [modalContent, setModalContent] = useState<string>("");
  const [twoDogMsg, setTwoDogsMsg] = useState<string>("");

  // NOTE: for AKC Team / Brace / Pairs levels purposes (extra dogs picker)
  const [usingTeamDogs, setUsingTeamDogs] = useState<boolean>(false);

  const [dogDetailsError, setDogDetailsError] = useState<string>();

  const defaultPaymentSummary:ITransactionPaymentSummary = useMemo(() => {
    return {
      account_number: "",
      base_amount: 0,
      discount: 0,
      currency: "USD",
      calculated_application_fee: 0,
      calculated_processing_fee: 0,
      calculated_processing_tax: 0,
      fees: 0,
      total_amount: 0,
      details: []
    };
  }, []);

  const [userAddress, setUserAddress] = useState<IAddress>();
  const [userPhone, setUserPhone] = useState<string>();

  const [paymentSummary, setPaymentSummary] = useState<ITransactionPaymentSummary>(defaultPaymentSummary);

  //const [clubPaymentMethods, setClubPaymentMethods] = useState<IRadioListItem[]>([]);
  const [cardToDelete, setCardToDelete] = useState<{label: string, id: string}>();
  //const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<number>(0);

  // DO - this will change...
  const onBehalfPaymentMethods: IOption[] = [
    { value: "Cash", id: Constants.payment_method_type.cash },
    { value: "E-Transfer", id: Constants.payment_method_type.etransfer },
    { value: "Paypal", id: Constants.payment_method_type.paypal },
    { value: "Cheque", id: Constants.payment_method_type.cheque },
    { value: "Other", id: Constants.payment_method_type.other }
  ];

  const akcTitles: IOption[] = [
    { value: "FCAT - 1000 pts", id: Constants.akc_fastcat_titles.fcat},
    { value: "DCAT - 500 pts", id: Constants.akc_fastcat_titles.dcat},
    { value: "BCAT - 150 pts", id: Constants.akc_fastcat_titles.bcat},
  ];

  const [onBehalfPaymentMethod, setOnBehalfPaymentMethod] = useState<IOption>({ value: "Cash", id: Constants.payment_method_type.cash });
  const [chequeNumber, setChequeNumber] = useState<string | undefined>(undefined);

  const getDogs = useCallback((id?: string, clubId?: string) => {
    apiService.getUserDogs(id ? id : user._id).then((dogResponse) => {
      if (clubId) {
        apiService.getUserDogs(id ? id : user._id, clubId).then((clubResponse) => {
          setDogs([...dogResponse, ...clubResponse]);
        });
      } else {
        if (dogResponse.length > 0) {
          setDogs(dogResponse);
        }
      }
    });
  }, [user._id]);

  const canEditDog = (show: any, dog: any) => {
    if (user.user_type !== Constants.user_type.club_manager) {
      return true;
    } else {
      if (show.created_by === user._id && show.club_id === dog.club_id) {
        return true;
      } else {
        return false;
      }
    }
  }

  const updatePaymentSummary = useCallback((discount?: string) => {
    let _shows:IShowDogs[] = JSON.parse(JSON.stringify(shows));
    let hasClasses:boolean = false;

    /*const getDockJumpingClasses = (_classes: any) => {
      let _dockJumpingClasses = JSON.parse(JSON.stringify(_classes));

      for (let c in _dockJumpingClasses) {
        _dockJumpingClasses[c].show_element = _dockJumpingClasses[c].level;
        delete _dockJumpingClasses[c].level;
      }

      return _dockJumpingClasses;
    }*/

    setDogDetailsError(undefined);

    let _payload:EventDogShowsDto[] = [];

    if (_shows.length > 0) {
      for (let s in _shows) {
        if (_shows[s].dogs.length > 0) {
          let _showDogs:any = {
            show_id: _shows[s]._id,
            dogs: []
          }

          // TODO: temp hotfix; level value override for ABI Conformation: "Altered Conformation" -> "Altered" to pass BE DogClass schema enum validation
          for (let d in _shows[s].dogs) {
            const dogClassesMutated = _shows[s].dogs[d].classes?.map((dc) => {
              if (
                Constants.sanctioning_club.ABI === event.sanctioning_club &&
                _shows[s].show_type === Constants.show_type.conformation &&
                dc.level === Constants.dog_class_element.conformation_altered
              ) {
                return {
                  ...dc,
                  level: "Altered",
                };
              }
              return dc;
            })

            let _dog:any = {
              dog_id: _shows[s].dogs[d]._id,
              dog_classes: /*_shows[s].show_type === Constants.show_type.dock_jumping ? getDockJumpingClasses(_shows[s].dogs[d].classes) : */ dogClassesMutated,
              plan_to_earn_title: _shows[s].dogs[d].plan_to_earn_title !== undefined ? _shows[s].dogs[d].plan_to_earn_title : false,
              title: _shows[s].dogs[d].title,
              using_agent: _shows[s].dogs[d].using_agent !== undefined ? _shows[s].dogs[d].using_agent : false,
              agent_name: _shows[s].dogs[d].agent_name,
              agent_number: _shows[s].dogs[d].agent_number,
              using_non_agent: _shows[s].dogs[d].using_non_agent,
              agent_phone: _shows[s].dogs[d].agent_phone,
              agent_email: _shows[s].dogs[d].agent_email,
              substitute_name: _shows[s].dogs[d].substitute_name,
              substitute_email: _shows[s].dogs[d].substitute_email,
              substitute_phone: _shows[s].dogs[d].substitute_phone,
              // NOTE: "validate" leg info value; for junior/apprentice should be blank
              leg_info: [Constants.dog_class_element.working,
                Constants.dog_class_element.courier,
                Constants.dog_class_element.master
              ].includes(dogClassesMutated?.[0]?.level ?? "") ? _shows[s].dogs[d].leg_info : undefined,
              splashes: _shows[s].dogs[d].splashes
            };

            let hasTimeSlot:any = _shows[s]?.dogs[d]?.classes?.filter((i: any) => { return i.time_slot !== undefined; });

            if (hasTimeSlot && hasTimeSlot.length > 0) {
              _dog.time_slot = hasTimeSlot[0].time_slot;
            }

            _showDogs.dogs.push(_dog);

            const _classLength = _shows[s]?.dogs[d]?.classes?.length;

            if (_classLength) {
              hasClasses = true;
            }
          }

          _payload.push(_showDogs);
        }
      }

      if (event && hasClasses) {
        let payload:EventRegistrationCreateDto = {
          registration_kind: onBehalf !== undefined && onBehalfEmail !== undefined ? Constants.registration_kind.club : Constants.registration_kind.owner,
          payment_method_type: onBehalf !== undefined && onBehalfEmail !== undefined ? onBehalfPaymentMethod.id.toLowerCase() : "card",
          owner_id: onBehalf || user._id,
          "dog_show_registrations": _payload,
        }

        if (discount) {
          payload.discount_code = discount;
        }

        if (paymentIntentId) {
          payload.payment_intent_id = paymentIntentId;
        }

        if (transactionId) {
          payload.transaction_id = transactionId;
        }

        apiService.getRegistrationPaymentSummary(event._id, payload).then((response) => {
          if (response) {
            setRegPayload(_payload);
            setPaymentSummary(response);

            if (onBehalf === undefined && onBehalfEmail === undefined) {
              setStripePromise(loadStripe(Config.web.REACT_APP_STRIPE_PUBLIC_KEY || "", { stripeAccount: response.account_number }));
            } else {
              setStripePromise(loadStripe(Config.web.REACT_APP_STRIPE_PUBLIC_KEY || ""));
            }

            if (discount && response.discount > 0) {
              toast.show({
                title: "Discount Applied",
                content: "A discount has been applied",
                duration: 10000,
                type: "success"
              });
            } else if (discount) {
              toast.show({
                title: "Discount Invalid",
                content: "The discount code you entered is invalid",
                duration: 10000,
                type: "fail"
              });
            }
          }
        }).catch((e: any) => {
          if (e.response?.data?.message) {
            setDogDetailsError(e.response?.data?.message);
          }

          toast.show({
            title: "Event Register",
            content: e.response?.data?.message ? e.response?.data?.message : "Something went wrong while getting the payment summary",
            duration: 10000,
            errorDetails: e,
            type: "fail"
          });
        });
      } else {
        setPaymentSummary(defaultPaymentSummary);
      }
    }
  }, [defaultPaymentSummary, event, shows, onBehalf, onBehalfEmail, paymentIntentId, transactionId, onBehalfPaymentMethod.id, user._id]);

  const updateDogInfo = (showIndex: number, dogIndex: number, classes: any[]) => {
    let _shows:IShowDogs[] = JSON.parse(JSON.stringify(shows));
    _shows[showIndex].dogs[dogIndex].classes = classes;

    setShows(_shows);
  }

  const updateDogInfoAllShowTypes = (showType: string, classes: IDogClass[], dog: IDog) => {
    let _shows:IShowDogs[] = JSON.parse(JSON.stringify(shows));

    for (let s in _shows) {
      if (_shows[s].show_type === showType) {
        let _dog:IDogInfo[] = _shows[s].dogs.filter((d: IDogInfo, index: number) => d._id === dog._id);

        if (_dog[0]) {
          _dog[0].classes = classes;
        }
      }
    }

    setShows(_shows);
  }

  const handleDogUpdated = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const uid = queryParameters.get("uid");

    if (onBehalf && onBehalfEmail && event && uid) {
      getDogs(uid, event.club_id);
    } else if (event) {
      getDogs(undefined, event.club_id);
    }
  }

  /*const hasAddress = (validateDog: any) => {
    if (validateDog.coowners && validateDog.coowners.length > 0) {
      if ((!validateDog.coowners[0].address.city || validateDog.coowners[0].address.city.length === 0) ||
          (!validateDog.coowners[0].address.country || validateDog.coowners[0].address.country.length === 0) ||
          (!validateDog.coowners[0].address.state || validateDog.coowners[0].address.state.length === 0) ||
          (!validateDog.coowners[0].address.postal_code || validateDog.coowners[0].address.postal_code.length === 0) ||
          (!validateDog.coowners[0].address.line1 || validateDog.coowners[0].address.line1.length === 0)) {
        return validateDog.call_name + " is missing owner address information (Country, State, City, ZIP, and Address). You can add owner information by editing your dog information.";
      } else {
        return "";
      }
    }

    return "";
  }*/

  const validateAKCDogSelect = (selectedShow: IShow, validateDog: IDog) => {
    let errorMsg = "";
    let hasPALNum = validateDog.registration_numbers.filter((n: any) => (n.type === Constants.registration_number_type.akc_pal && n.name === Constants.sanctioning_club.AKC)).length > 0;

    switch (selectedShow.show_type) {
      case Constants.show_type.conformation:
        /*if (validateDog.coowners && validateDog.coowners.length === 0) {
          errorMsg = validateDog.call_name + " doesn't have owner information and can't register to this show. You can add owner information by editing your dog information.";
        }*/

        /*if (validateDog.coowners && validateDog.coowners.length > 0) {
          errorMsg = hasAddress(validateDog);
        }*/

        if ((!validateDog.sire || validateDog.sire.length === 0) && !hasPALNum) {
          errorMsg = validateDog.call_name + " is missing a Sire. You can add a sire by editing your dog information (under the basic information tab).";
        }

        if ((!validateDog.dam || validateDog.dam.length === 0) && !hasPALNum) {
          errorMsg = validateDog.call_name + " is missing a Dam. You can add a dam by editing your dog information (under the basic information tab).";
        }

        if ((!validateDog.breeder || validateDog.breeder.length === 0) && !hasPALNum) {
          errorMsg = validateDog.call_name + " is missing a breeder. You can add a breeder by editing your dog information (under the basic information tab).";
        }

        /*if (onBehalf === undefined && onBehalfEmail === undefined && ((!user.emergency_contact_name || user.emergency_contact_name.length === 0) || (!user.emergency_contact_phone || user.emergency_contact_phone.length === 0))) {
          errorMsg = "Your account is missing an emergency contact name and/or phone number. You can add emergency contact information on your account settings page (accessible in the top right corner).";
        }*/
      break;
      case Constants.show_type.fast_cat:
          /*if (validateDog.coowners && validateDog.coowners.length === 0) {
            errorMsg = validateDog.call_name + " doesn't have owner information and can't register to this show. You can add owner information by editing your dog information.";
          }*/

          /*if (validateDog.coowners && validateDog.coowners.length > 0) {
            errorMsg = hasAddress(validateDog);
          }*/

          /*
          if ((!validateDog.sire || validateDog.sire.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a Sire. You can add a sire by editing your dog information (under the basic information tab).";
          }

          if ((!validateDog.dam || validateDog.dam.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a Dam. You can add a dam by editing your dog information (under the basic information tab).";
          }
            */
      break;
      case Constants.show_type.fetch:
          /*if (validateDog.coowners && validateDog.coowners.length === 0) {
            errorMsg = validateDog.call_name + " doesn't have owner information and can't register to this show. You can add owner information by editing your dog information.";
          }*/

          /*if (validateDog.coowners && validateDog.coowners.length > 0) {
            errorMsg = hasAddress(validateDog);

            if (validateDog.coowners[0].email === "") {
              errorMsg = validateDog.call_name + " doesn't have an owner email set and can't register to this show. You can add owner information by editing your dog information.";
            }

            if (validateDog.coowners[0].phone === "") {
              errorMsg = validateDog.call_name + " doesn't have an owner phone number set and can't register to this show. You can add owner information by editing your dog information.";
            }
          }*/
        
          /*if ((!validateDog.sire || validateDog.sire.length === 0) && !hasPALNum) {
          
          /*
          if ((!validateDog.sire || validateDog.sire.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a Sire. You can add a sire by editing your dog information (under the basic information tab).";
          }

          if ((!validateDog.dam || validateDog.dam.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a Dam. You can add a dam by editing your dog information (under the basic information tab).";
          }*/
      break;
      case Constants.show_type.obedience:
          /*if (validateDog.coowners && validateDog.coowners.length > 0) {
            errorMsg = hasAddress(validateDog);
          }*/

            /*
          if ((!validateDog.sire || validateDog.sire.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a Sire. You can add a sire by editing your dog information (under the basic information tab).";
          }

          if ((!validateDog.dam || validateDog.dam.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a Dam. You can add a dam by editing your dog information (under the basic information tab).";
          }

          if ((!validateDog.breeder || validateDog.breeder.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a breeder. You can add a breeder by editing your dog information (under the basic information tab).";
          }*/

          /*if (onBehalf === undefined && onBehalfEmail === undefined && ((!user.emergency_contact_name || user.emergency_contact_name.length === 0) || (!user.emergency_contact_phone || user.emergency_contact_phone.length === 0))) {
            errorMsg = "Your account is missing an emergency contact name and/or phone number. You can add emergency contact information on your account settings page (accessible in the top right corner).";
          }*/

          /*if (!validateDog.obedience_jump_height || validateDog.obedience_jump_height <= 0) {
            errorMsg = validateDog.call_name + " is missing an obedience jump height and can't register for this show. You can add an obedience jump height by editing your dogs information.";
          }*/
      break;
      case Constants.show_type.rally_obedience:
          /*if (validateDog.coowners && validateDog.coowners.length > 0) {
            errorMsg = hasAddress(validateDog);
          }*/

          /*
          if ((!validateDog.sire || validateDog.sire.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a Sire. You can add a sire by editing your dog information (under the basic information tab).";
          }

          if ((!validateDog.dam || validateDog.dam.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a Dam. You can add a dam by editing your dog information (under the basic information tab).";
          }

          if ((!validateDog.breeder || validateDog.breeder.length === 0) && !hasPALNum) {
            errorMsg = validateDog.call_name + " is missing a breeder. You can add a breeder by editing your dog information (under the basic information tab).";
          }*/

          /*if (onBehalf === undefined && onBehalfEmail === undefined && ((!user.emergency_contact_name || user.emergency_contact_name.length === 0) || (!user.emergency_contact_phone || user.emergency_contact_phone.length === 0))) {
            errorMsg = "Your account is missing an emergency contact name and/or phone number. You can add emergency contact information on your account settings page (accessible in the top right corner).";
          }*/

          /*if (!validateDog.rally_jump_height || validateDog.rally_jump_height <= 0) {
            errorMsg = validateDog.call_name + " is missing a rally jump height and can't register for this show. You can add an rally jump height by editing your dogs information.";
          }*/
      break;
    }


    if (errorMsg.length > 0) {
      toast.show({
        title: "Registration",
        content: errorMsg,
        duration: 10000,
        type: "fail",
        dog: validateDog,
        onDogEdit: () => {
          handleDogUpdated();
        },
        canEdit: canEditDog(selectedShow, validateDog)
      });

      return false;
    } else {
      return true;
    }
  }

  const validateUKCDogSelect = (selectedShow: IShow, validateDog: IDog) => {
    let errorMsg = "";

    if (onBehalf === undefined && onBehalfEmail === undefined && user.is_junior) {
      let juniorEnabledShows:string[] = [
        Constants.show_type.nosework,
        Constants.show_type.conformation,
        Constants.show_type.obedience,
        Constants.show_type.rally_obedience,
        Constants.show_type.agility
      ];

      if (!juniorEnabledShows.includes(selectedShow.show_type)) {
        errorMsg = "Junior accounts cannot register to UKC " + selectedShow.show_type + " shows.";
      }
    }

    switch (selectedShow.show_type) {
      case Constants.show_type.obedience:
        if (!validateDog.jump_height_type) {
          errorMsg = validateDog.call_name + " is missing an obedience jump height type and can't register for this show. You can add an obedience jump height type by editing your dogs information.";
        }
      break;
      case Constants.show_type.rally_obedience:
        if (!validateDog.height_at_withers) {
          errorMsg = validateDog.call_name + " is missing an height at the withers and can't register for this show. You can add height at the withers by editing your dogs information.";
        }
        if (!validateDog.jump_height_type) {
          errorMsg = validateDog.call_name + " is missing an obedience jump height type and can't register for this show. You can add an obedience jump height type by editing your dogs information.";
        }
      break;
    }


    if (errorMsg.length > 0) {
      toast.show({
        title: "Registration",
        content: errorMsg,
        duration: 10000,
        type: "fail",
        dog: validateDog,
        onDogEdit: () => {
          handleDogUpdated();
        },
        canEdit: canEditDog(selectedShow, validateDog)
      });

      return false;
    } else {
      return true;
    }
  }

  const isPuppy = (showIndex:number, dog:IDogInfo) => {
    let _dob = moment(dog.dob);
    let _shows:IShowDogs[] = JSON.parse(JSON.stringify(shows));
    let _showDate = moment(_shows[showIndex].show_date);
    

    return _showDate.diff(_dob, "months") < 6 && _showDate.diff(_dob, "months") >= 3;
  }

  const selectDog = (showIndex:number, dog:IDogInfo) => {
    let _shows:IShowDogs[] = JSON.parse(JSON.stringify(shows));
    let _foundDog:boolean = false;
    let _hasRegistrationNumber:boolean = dog.registration_numbers.filter((n) => {
      // NOTE: use CKC number for PWDCA events
      if (event.sanctioning_club === Constants.sanctioning_club.PWDCA) {
        return event && n.name === Constants.sanctioning_club.CKC
      }
      return event && n.name === event.sanctioning_club
    }).length > 0;

    if (_shows[showIndex].excluded_breeds !== undefined && _shows[showIndex].excluded_breeds?.includes(dog.breed)) {
      toast.show({
        title: "Select Dog",
        content: dog.call_name + "'s dog breed ("+ dog.breed +") isn't allowed for this show",
        duration: 10000,
        type: "fail"
      });

      return false;
    }

    switch(event?.sanctioning_club) {
      case Constants.sanctioning_club.AKC:
        if (!validateAKCDogSelect(_shows[showIndex], dog)) {
          return false;
        }
      break;
      case Constants.sanctioning_club.UKC:
        if (!validateUKCDogSelect(_shows[showIndex], dog)) {
          return false;
        }
      break;
    }

    if ((_shows[showIndex].show_type === Constants.show_type.agility || _shows[showIndex].show_type === Constants.show_type.fast_cat) && (!dog.height_at_withers || dog.height_at_withers <= 0)) {
      toast.show({
        title: "Select Dog",
        content: dog.call_name + " doesn't have a value set for 'height at withers' and cannot register for your shows. You can add a value for your dogs 'height at withers' on your account settings page",
        duration: 10000,
        type: "fail",
        dog: dog,
        onDogEdit: () => {
          handleDogUpdated();
        },
        canEdit: canEditDog(_shows[showIndex], dog)
      });
    } else if (!_hasRegistrationNumber && !(event.sanctioning_club === Constants.sanctioning_club.UKC && _shows[showIndex].show_type === Constants.show_type.conformation && isPuppy(showIndex, dog)) && event) {
      toast.show({
        title: "Select Dog",
        content: dog.call_name + " doesn't have a(n) " + `${event.sanctioning_club === Constants.sanctioning_club.PWDCA ? 'CKC' : event.sanctioning_club}` + " registration number and cannot register for this event",
        duration: 10000,
        type: "fail",
        dog: dog,
        onDogEdit: () => {
          handleDogUpdated();
        },
        canEdit: canEditDog(_shows[showIndex], dog)
      });
    } else if (_shows[showIndex].max_dogs !== undefined && (_shows[showIndex].max_dogs || 0) - (_shows[showIndex].registered_dogs || 0) === 0) {
      toast.show({
        title: "Dog Registration",
        content: "There aren't any available spots for that show",
        duration: 10000,
        type: "fail",
        dog: dog,
        onDogEdit: () => {
          handleDogUpdated();
        },
        canEdit: canEditDog(_shows[showIndex], dog)
      });
    } else {
      let _dog = JSON.parse(JSON.stringify(dog));
      _dog.classes = [];

      for (let d in _shows[showIndex].dogs) {
        if (_shows[showIndex].dogs[d]._id === dog._id) {
          _shows[showIndex].dogs.splice(parseInt(d), 1);
          _foundDog = true;
          break;
        }
      }

      if (!_foundDog) {
        _shows[showIndex].dogs.push(_dog);
      }
      
      setShows(_shows);
    }
  }

  const showTypeHasDogs = (showType: string) => {
    for (let s in shows) {
      if (shows[s].show_type === showType) {
        if (shows[s].dogs.length > 0) {
          return shows[s].dogs.length;
        }
      }
    }

    return 0;
  }

  const allDogsHaveClasses = () => {
    for (let s in shows) {
      for (let d in shows[s].dogs) {
        let _classes = shows[s].dogs[d].classes;

        if (!helperService.timeSlotShows.includes(shows[s].show_type)) {
          if (!_classes || _classes.length === 0) {
            return false;
          }
        }
      }
    }

    return true;
  }

  const dogsAgentsValidate = () => {
    const errors = []
    for (let s in shows) {
      for (let d in shows[s].dogs) {
        if (shows[s].dogs[d].using_agent) {
          if (!shows[s].dogs[d].agent_name) errors.push('name');
          if (!shows[s].dogs[d].agent_number) errors.push('number');
          // NOTE: check agent's phone presence on Water dog event show
          if (shows[s].show_type === Constants.show_type.water_dog) {
            if (!helperService.isValidEmail(shows[s].dogs[d].agent_email ?? '')) errors.push('email');
            if (!isPossiblePhoneNumber(shows[s].dogs[d].agent_phone ?? '')) errors.push('phone');
          }
        }
      }
    }

    return errors;
  }

  // NOTE: PWDCA Water dog specific check
  const dogsSubstituteValidate = () => {
    const errors = []
    for (let s in shows) {
      if (shows[s].show_type === Constants.show_type.water_dog) {
        for (let d in shows[s].dogs) {
          if (!shows[s].dogs[d].substitute_name) errors.push('name');
          if (!helperService.isValidEmail(shows[s].dogs[d].substitute_email ?? '')) errors.push('email');
          if (!isPossiblePhoneNumber(shows[s].dogs[d].substitute_phone ?? '')) errors.push('phone');
        }
      }
    }
    return errors;
  }

  const next = () => {
    let valid:boolean = true;

    let dogMsg:string = "";

    if (dogDetailsError !== undefined) {
      toast.show({
        title: "Event Registration",
        content: dogDetailsError,
        duration: 10000,
        type: "fail"
      });

      valid = false;
    }

    switch (currentStep) {
      case 0:
        let _hasDogs: boolean = false;

        for (let s in showTypes) {
          let hasDogs:number = showTypeHasDogs(showTypes[s]);

          if (hasDogs > 0) {
            _hasDogs = true;
          }

          if (hasDogs > 1) {
            if (dogMsg.length > 0) {
              dogMsg = "Looks like you've placed a few dogs onto a single show, multiple times. Was this intentional?";
            } else {
              dogMsg = "Looks like you've placed "+ hasDogs +" dogs onto a single " + showTypes[s] + " show. Was this intentional?";
            }

            valid = false;
          }
        }

        if (dogMsg) {
          setTwoDogsMsg(dogMsg);
          setModalContent("twoDogs");
        }

        if (!_hasDogs) {
          toast.show({
            title: "Event Registration",
            content: "Please add at least one dog to a show",
            duration: 10000,
            type: "fail"
          });

          valid = false;
        }
      break;
      case 1:
        if (!allDogsHaveClasses()) {
          toast.show({
            title: "Event Registration",
            content: "Each registered dog must have at least one class chosen per show",
            duration: 10000,
            type: "fail"
          });

          valid = false;
        }

        const agentsErrors = dogsAgentsValidate();
        if (valid && agentsErrors.length) {
          toast.show({
            title: "Event Registration",
            content: `Missing an agent/handler ${agentsErrors.join(', ')}`,
            duration: 10000,
            type: "fail"
          });

          valid = false;
        }

        let hasConforObed = shows.filter((s: IShow) => s.show_type === Constants.show_type.conformation || s.show_type === Constants.show_type.obedience);

        const substituteErrors = dogsSubstituteValidate();
        if (valid && substituteErrors.length) {
          substituteErrors.forEach((error) => {
            if (['email', 'phone'].includes(error)) {
              toast.show({
                title: "Event Registration",
                content: `Please enter a valid substitute steward ${error}`,
                duration: 10000,
                type: "fail"
              });
            } else {
              toast.show({
                title: "Event Registration",
                content: `Missing a substitute steward ${error}`,
                duration: 10000,
                type: "fail"
              });
            }
          })

          valid = false;
        }

        let hasNoseworkOrRatRace = shows.filter((s: IShow) => s.show_type === Constants.show_type.nosework || s.show_type === Constants.show_type.urban_rat_race);

        if (hasNoseworkOrRatRace.length > 0) {
          for (let s in hasNoseworkOrRatRace) {
            for (let d in hasNoseworkOrRatRace[s].dogs) {
              let hasNone = hasNoseworkOrRatRace[s].dogs[d].classes?.filter((cl: IDogClass) => cl.section === "None");

              if (hasNone && hasNone.length > 0) {
                toast.show({
                  title: "Event Registration",
                  content: "Please select a Section for all the elements you've selected in your "+ hasNoseworkOrRatRace[s].show_type +" show(s)",
                  duration: 10000,
                  type: "fail"
                });

                valid = false;
                return;
              }
            }
          }
        }

        let hasTimeSlotShows = shows.filter((s: IShow) => (s.show_type === Constants.show_type.fast_cat || s.show_type === Constants.show_type.fetch));

        if (hasTimeSlotShows.length > 0) {
          for (let s in hasTimeSlotShows) {
            for (let d in hasTimeSlotShows[s].dogs) {
              let hasDogWithTimeSlot = hasTimeSlotShows[s]?.dogs[d]?.classes?.filter((c: any) => { return c.time_slot !== undefined });

              if (hasDogWithTimeSlot && hasDogWithTimeSlot.length === 0) {
                toast.show({
                  title: "Event Registration",
                  content: "Please select a timeslot for all the elements you've selected in your "+ hasTimeSlotShows[s].show_type +" show(s)",
                  duration: 10000,
                  type: "fail"
                });

                valid = false;
                return;
              }
            }
          }
        }

        let hasObedienceOrConformation = shows.filter((s: IShow) => [Constants.show_type.obedience, Constants.show_type.rally_obedience, Constants.show_type.conformation].includes(s.show_type));
        if (hasObedienceOrConformation.length) {
          for (let s in hasObedienceOrConformation) {
            for (let d in hasObedienceOrConformation[s].dogs) {
              let teamsLevel = hasObedienceOrConformation[s].dogs[d]?.classes?.filter((cl: IDogClass) => cl.level === Constants.dog_class_element_level.team);
              let braceLevels = hasObedienceOrConformation[s].dogs[d]?.classes?.filter((cl: IDogClass) => cl.level === Constants.dog_class_element_level.brace);
              let pairsLevels = hasObedienceOrConformation[s].dogs[d]?.classes?.filter((cl: IDogClass) => cl.level === Constants.dog_class_element_level.pairs);

              if (teamsLevel?.length) {
                teamsLevel.forEach((level) => {
                  if (level?.extra_arr?.length !== 3) {
                    toast.show({
                      title: "Event Registration",
                      content: "Please select 3 teammates for your dog on " + hasObedienceOrConformation[s].show_type + " show' Team level",
                      duration: 10000,
                      type: "fail"
                    });

                    valid = false;
                  }
                });
              }

              if (braceLevels?.length) {
                braceLevels.forEach((level) => {
                  if (!level?.extra) {
                    toast.show({
                      title: "Event Registration",
                      content: "Please select a teammate for your dog on "+ hasObedienceOrConformation[s].show_type +" show' Brace level",
                      duration: 10000,
                      type: "fail"
                    });

                    valid = false;
                  }
                });
              }

              if (pairsLevels?.length) {
                pairsLevels.forEach((level) => {
                  if (!level?.extra) {
                    toast.show({
                      title: "Event Registration",
                      content: "Please select a teammate for your dog on "+ hasObedienceOrConformation[s].show_type +" show' Pairs level",
                      duration: 10000,
                      type: "fail"
                    });

                    valid = false;
                  }
                });
              }

              if (!valid) return;
            }
          }
        }

        // let hasDockJumping = shows.filter((s: IShow) => (s.show_type === Constants.show_type.dock_jumping));

        // if (hasDockJumping.length > 0) {
        //   for (let s in hasDockJumping) {
        //     for (let d in hasDockJumping[s].dogs) {
        //       let hasDogWithAir = hasDockJumping[s]?.dogs[d]?.classes?.filter((c: any) => { return c.level === Constants.dog_class_element_level.dock_jumping_air; });

        //       if (hasDogWithAir && hasDogWithAir.length > 0) {
        //         for (let dd in hasDogWithAir) {
        //           if (!hasDogWithAir[dd].multiplier) {
        //             toast.show({
        //               title: "Event Registration",
        //               content: "Please enter a number of splashes for each dog in dock jumping air",
        //               duration: 10000,
        //               type: "fail"
        //             });

        //             valid = false;
        //             return;
        //           } else if (Number(hasDogWithAir[dd].multiplier) <= 0 || Number(hasDogWithAir[dd].multiplier) > 6) {
        //             toast.show({
        //               title: "Event Registration",
        //               content: "Please enter a valid number of splashes for each dog in dock jumping air (between 1 and 6)",
        //               duration: 10000,
        //               type: "fail"
        //             });

        //             valid = false;
        //             return;
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
      break;
      case 2:
        if (!agreeToWaiver) {
          valid = false;

          toast.show({
            title: "Event Registration",
            content: "You must agree to the Waiver to continue",
            duration: 10000,
            type: "fail"
          });
        }
      break;
      case 3:
        if (!agreeToEventWaiver) {
          valid = false;

          toast.show({
            title: "Event Registration",
            content: "You must agree to the Waiver to continue",
            duration: 10000,
            type: "fail"
          });
        }
      break;
    }

    if (valid) {
      let hasFastCat: any[] = shows.filter((s: any) => s.show_type === Constants.show_type.fast_cat);

      if (hasFastCat.length > 0 && currentStep === 1) {
        checkFastCatDiffTimeSlots(hasFastCat);
      } else {
        if (currentStep === 2) {
          if (event.waiver && event.waiver !== ' ' && event.waiver !== '') {
            setCurrentStep(currentStep + 1);
          }
          else {
            setCurrentStep(currentStep + 2);
          }
        } else {
          setCurrentStep(currentStep + 1);
        }
      }
    }
  }

  const checkFastCatDiffTimeSlots = (hasFastCat: any[]) => {
    let dogMsg:string = "";
    let mergedTimeSlotsPerDog: any[] = [];

    for (let s in hasFastCat) {
      let _timeslot_name:string = "";

      for (let d in hasFastCat[s].dogs) {
        if (!mergedTimeSlotsPerDog[hasFastCat[s].dogs[d]._id]) {
          mergedTimeSlotsPerDog[hasFastCat[s].dogs[d]._id] = {
            name: hasFastCat[s].dogs[d].registered_name,
            timeSlots: []
          };
        }

        for (let c in hasFastCat[s].dogs[d].classes) {
          mergedTimeSlotsPerDog[hasFastCat[s].dogs[d]._id].timeSlots.push(hasFastCat[s].dogs[d].classes[c].time_slot);

          if (_timeslot_name.length === 0) {
            _timeslot_name = hasFastCat[s].dogs[d].classes[c].time_slot;
          } else if (_timeslot_name !== hasFastCat[s].dogs[d].classes[c].time_slot) {
            dogMsg = "Looks like you have multiple dogs in a single trial with different timeslots. Was this intentional?";
            break;
          }
        }
      }
    }

    if (Object.keys(mergedTimeSlotsPerDog).length === 1) {
      for (let d in mergedTimeSlotsPerDog) {
        for (let t in mergedTimeSlotsPerDog[d].timeSlots) {
          if (mergedTimeSlotsPerDog[d].timeSlots[t] !== mergedTimeSlotsPerDog[d].timeSlots[0]) {
            dogMsg = "Looks like "+ mergedTimeSlotsPerDog[d].name +" is registered for multiple trials, but in different timeslots. Was this intentional?";
          }
        }
      }
    }

    if (dogMsg.length > 0) {
      setTwoDogsMsg(dogMsg);
      setModalContent("twoDogs");
    } else {
      if (currentStep === 2) {
        if (event.waiver && event.waiver !== ' ' && event.waiver !== '') {
          setCurrentStep(currentStep + 1);
        }
        else {
          setCurrentStep(currentStep + 2);
        } 
      }
      else {
        setCurrentStep(currentStep + 1);
      }
    }
  }

  const previous = () => {
    setCurrentStep(currentStep - 1);
  }

  const getDogIds = () => {
    let dogIds:string[] = [];

    for (let s in shows) {
      for (let d in shows[s].dogs) {
        if (!dogIds.includes(shows[s].dogs[d]._id)) {
          dogIds.push(shows[s].dogs[d]._id);
        }
      }
    }

    return dogIds.join();
  }

  const dogInShowType = (dog:IDog, showType: string) => {
    let _filteredShows = shows.filter((show:IShowDogs) => show.show_type === showType && show.dogs.filter((d: IDogInfo) => d._id === dog._id).length > 0);

    return _filteredShows.length > 0 ? true : false;
  }

  const getJoinedShow = (dog:IDogInfo, showType: string) => {
    let _filteredShows = shows.filter((show:IShowDogs) => show.show_type === showType && show.dogs.filter((d: IDogInfo) => d._id === dog._id).length > 0);
    let _show:IShowDogs = JSON.parse(JSON.stringify(_filteredShows[0]));

    for (let s in shows) {
      if (shows[s].show_type === showType && shows[s].dogs.filter((d: IDogInfo) => d._id === dog._id).length > 0) {
        _show.show_elements = _show.show_elements.concat(shows[s].show_elements);
      }
    }

    _show.show_elements = _show.show_elements.filter((v:IShowElement, i:number, a:IShowElement[]) => a.findIndex(v2 => (JSON.stringify(v2) === JSON.stringify(v))) === i);

    return _show;
  }

   /*const getClubCards = (clubId: string) => {
    apiService.getClubPaymentMethods(clubId).then((clubPaymentMethodsResponse) => {
      let _radioItems:IRadioListItem[] = [];

      for (let i in clubPaymentMethodsResponse) {
        _radioItems.push({
          id: clubPaymentMethodsResponse[i].id,
          label: clubPaymentMethodsResponse[i].card.display_brand.toUpperCase() + " ending in " + clubPaymentMethodsResponse[i].card.last4,
          action: {
            label: "(remove)",
            onClick: () => { setModalContent("confirmRemoveCard"); setCardToDelete({ label: clubPaymentMethodsResponse[i].card.display_brand.toUpperCase() + " ending in " + clubPaymentMethodsResponse[i].card.last4, id: clubPaymentMethodsResponse[i].id }); }
          }
        })
      }

      setClubPaymentMethods(_radioItems);
    });
   }*/

   const toggleUsingAgentJoined = (_shows: IShowDogs[], _dog: any, _showType: string) => {
    let __shows = JSON.parse(JSON.stringify(_shows));

    for (let s in __shows) {
      if (__shows[s].show_type === _showType) {
        for (let d in __shows[s].dogs) {
          if (__shows[s].dogs[d]._id === _dog._id) {
            if (__shows[s].dogs[d].using_agent === undefined) {
              __shows[s].dogs[d].using_agent = true;
            } else {
              __shows[s].dogs[d].using_agent = !__shows[s].dogs[d].using_agent;
            }

            break;
          }
        }
      }
    }

    setShows(__shows);
   }

   const toggleUsingAgentSingle = (_showIndex: number, _dogIndex: number) => {
      let __shows = JSON.parse(JSON.stringify(shows));

      if (__shows[_showIndex].dogs[_dogIndex].using_agent) {
        __shows[_showIndex].dogs[_dogIndex].using_agent = false;
      } else {
        __shows[_showIndex].dogs[_dogIndex].using_agent = true;
      }

      setShows(__shows);
   }

   const updateAgentJoined = (_shows: IShowDogs[], _dog: any, _showType: string, agent: AgentPayload) => {
    const { name, email, phone, number } = agent;
    let __shows = JSON.parse(JSON.stringify(_shows));

    for (let s in __shows) {
      if (__shows[s].show_type === _showType) {
        for (let d in __shows[s].dogs) {
          if (__shows[s].dogs[d]._id === _dog._id) {
            if (name !== undefined) { __shows[s].dogs[d].agent_name = name; }
            if (email !== undefined) { __shows[s].dogs[d].agent_email = email; }
            if (phone !== undefined) { __shows[s].dogs[d].agent_phone = phone; }
            if (number !== undefined) { __shows[s].dogs[d].agent_phone = number; }
            break;
          }
        }
      }
    }

    setShows(__shows);
   }

  // NOTE: PWDCA Water dog specific information
  const updateSubstituteJoined = (_shows: IShowDogs[], _dog: any, _showType: string, substitute: SubstitutePayload) => {
    const { name, phone, email } = substitute
    let __shows = JSON.parse(JSON.stringify(_shows));

    for (let s in __shows) {
      if (__shows[s].show_type === _showType) {
        for (let d in __shows[s].dogs) {
          if (__shows[s].dogs[d]._id === _dog._id) {
            if (name !== undefined) { __shows[s].dogs[d].substitute_name = name; }
            if (email !== undefined) { __shows[s].dogs[d].substitute_email = email; }
            if (phone !== undefined) { __shows[s].dogs[d].substitute_phone = phone; }
            break;
          }
        }
      }
    }

    setShows(__shows);
  }

  // NOTE: PWDCA Water dog specific information
  const updateDogLegInfo = (_shows: IShowDogs[], _dog: any, _showType: string, leg: string) => {
    let __shows = JSON.parse(JSON.stringify(_shows));

    for (let s in __shows) {
      if (__shows[s].show_type === _showType) {
        for (let d in __shows[s].dogs) {
          if (__shows[s].dogs[d]._id === _dog._id) {
            __shows[s].dogs[d].leg_info = leg;
            break;
          }
        }
      }
    }

    setShows(__shows);
  }

   const updateAgentSingle = (_showIndex: number, _dogIndex: number, agent: AgentPayload) => {
      const { name, number } = agent;
      let __shows = JSON.parse(JSON.stringify(shows));

      if (name !== undefined) __shows[_showIndex].dogs[_dogIndex].agent_name = name;
      if (number !== undefined) __shows[_showIndex].dogs[_dogIndex].agent_number = number;

      setShows(__shows);
   }

  const toggleUsingNonAgentSignle = (_showIndex: number, _dogIndex: number, _value: boolean) => {
    let __shows = JSON.parse(JSON.stringify(shows));

    __shows[_showIndex].dogs[_dogIndex].using_non_agent = _value;

    setShows(__shows);
  }

   const toggleEarnTitle = (_shows: IShowDogs[], _dogIndex: number, _showIndex?: number, allShows?: true) => {
    let __shows = JSON.parse(JSON.stringify(_shows));

    if (_showIndex !== undefined) {
      let _dog = __shows[_showIndex].dogs[_dogIndex];

      if (_dog.plan_to_earn_title) {
        _dog.plan_to_earn_title = false;
      } else {
        _dog.plan_to_earn_title = true;
      }
    } else if (allShows) {
      for (let s in __shows) {
        let _dog = __shows[s].dogs[_dogIndex];

        if (_dog.plan_to_earn_title) {
          _dog.plan_to_earn_title = false;
        } else {
          _dog.plan_to_earn_title = true;
        }
      }
    }

    setShows(__shows);
   }

   const title : IOption = { value: "BCAT - 150 pts", id: Constants.akc_fastcat_titles.bcat };

   const updateTitle = (_shows: IShowDogs[], _dogIndex: number, title: IOption, _showIndex?: number, allShows?: true) => {
    let __shows = JSON.parse(JSON.stringify(_shows));

    if (_showIndex !== undefined) {
      let _dog = __shows[_showIndex].dogs[_dogIndex];

      _dog.title = title.value;
    } else if (allShows) {
      for (let s in __shows) {
        let _dog = __shows[s].dogs[_dogIndex];

        _dog.title = title.value;
      }
    }

    setShows(__shows);
   }

  // On Page Load, Redirect Club Managers, Get Event Data, Shows
  useEffect(() => {
    if (!loaded && eid) {
      apiService.getEventSummaryForHandle(eid).then((response) => {
        setEvent(response);
        if (response.status === Constants.event_status.draft) {
          if (user._id !== response.created_by) {
            toast.show({
              title: "Event",
              content: "This event hasn't been published yet",
              duration: 10000,
              type: "fail"
            });

            navigate("/");
            return false;
          }
        }

        if (user.is_junior) {
          switch (response.sanctioning_club) {
            case Constants.sanctioning_club.UKC:
              if (user.junior_numbers?.filter((n: any) => { return n.name === Constants.sanctioning_club.UKC}).length === 0) {
                toast.show({
                  title: "Registration",
                  content: "You don't have a UKC Junior # attached to your account. Please add it on your account settings page.",
                  duration: 10000,
                  type: "fail"
                });

                navigate("/account");
              }
            break;
            case Constants.sanctioning_club.CKC:
              if (user.junior_numbers?.filter((n: any) => { return n.name === Constants.sanctioning_club.CKC}).length === 0) {
                toast.show({
                  title: "Registration",
                  content: "You don't have a CKC Junior # attached to your account. Please add it on your account settings page.",
                  duration: 10000,
                  type: "fail"
                });

                navigate("/account");
              }
            break;
            case Constants.sanctioning_club.AKC:
              if (user.junior_numbers?.filter((n: any) => { return n.name === Constants.sanctioning_club.AKC}).length === 0) {
                toast.show({
                  title: "Registration",
                  content: "You don't have an AKC Junior # attached to your account. Please add it on your account settings page.",
                  duration: 10000,
                  type: "fail"
                });

                navigate("/account");
              }
            break;
          }
        }

        const queryParameters = new URLSearchParams(window.location.search);
        const uid = queryParameters.get("uid");
        const uemail = queryParameters.get("uemail");
        const ujunior = queryParameters.get("junior");
        const claimed:boolean = queryParameters.get("claimed") === "true" ? true : false;
        setIsClaimed(claimed);

        if (user.user_type === "club_manager") {
          if (uid && uemail && ujunior && response.club.email === user.email) {
            setOnBehalf(uid);
            setOnBehalfEmail(uemail);
            setOnBehalfJunior(ujunior);

            /*if (response) {
              getClubCards(response.club_id);
            }*/
          } else {
            toast.show({
              title: "Event Registration",
              content: "Club owners aren't able to register to events",
              duration: 10000,
              type: "fail"
            });

            navigate("/");
          }
        } else if (user.user_type === "") {
          toast.show({
            title: "Event Registration",
            content: "You must be logged in to register to an event",
            duration: 10000,
            type: "fail"
          });

          let _url = window.location.href.split("/e/")[1];

          if (_url) {
            navigate("/login?r=/e/" + _url);
          } else {
            navigate("/login");
          }

          return false;
        }

        if (response.club_id && response._id) {
          if (uid && uemail) {
            getDogs(uid, response.club_id);
          } else {
            getDogs(undefined, response.club_id);
          }

          apiService.getClubEventShows(response.club_id, response._id, {
            sort: [{
              attribute_name: "show_date",
              sort: "asc"
            }]
          }).then((eventResponse) => {
            let _showDogs:IShowDogs[] = [];

            for (let s in eventResponse) {
              _showDogs[s] = { ...eventResponse[s], dogs: [] };
            }

            setShows(_showDogs);

            let _showTypes:string[] = [];

            for (let t in eventResponse) {
              if (!_showTypes.includes(eventResponse[t].show_type)) {
                _showTypes.push(eventResponse[t].show_type);
              }
            }

            setShowTypes(_showTypes);
          });
        }
      });
      setJoyrideSteps([{
        disableBeacon: true,
        placement: "top",
        target: ".EventRegister .registerInner .stepWrap .step .stepInner.selectShows",
        content: "This is a list of show types that this event is running trials for. Clicking on a show type will expand a list of trials the event is running for the selected show type."
      }, {
        disableBeacon: true,
        placement: "top",
        target: ".ShowTime",
        content: "Click on each dog's image to add or remove them from each trial. To add a new dog to your account, click New Dog."
      }, {
        disableBeacon: true,
        placement: "top",
        target: ".EventRegister .registerInner .stepWrap .actions button.joy",
        content: "When you're finished selecting all dogs for all trials you wish to enter, click next to proceed to the next step.  Make sure you've included all your dogs so you only have to register once!"
      }]);
    }

    setLoaded(true);
  }, [loaded, eid, getDogs, navigate, user.user_type, user.email, onBehalf, onBehalfEmail, user._id, user.is_junior, user.junior_numbers]);

  const findFirstShowWithDogs = useCallback(() => {
    let hasDogs = shows.filter((s: any) => { return s.dogs.length > 0; });

    if (hasDogs.length > 0) {
      let showIndex = showTypes.indexOf(hasDogs[0].show_type);
      return showIndex;
    }

    return 0;
  }, [showTypes, shows]);

  const prevShows = helperService.usePrevious(shows);
  const prevStep = helperService.usePrevious(currentStep);

  // On Payment Step, Get Payment Intent, Setup Payment Options
  useEffect(() => {
    if (prevStep !== currentStep) {
      if (prevStep === 0 && currentStep === 1) {
        let newIndex = findFirstShowWithDogs();
        setCurrentShow(newIndex);
      }

      if (currentStep === 4 && event && regPayload) {
        if (onBehalf === undefined && onBehalfEmail === undefined) {
          apiService.createRegistrationPaymentIntent(event._id, {
            registration_kind: onBehalf !== undefined && onBehalfEmail !== undefined ? Constants.registration_kind.club : Constants.registration_kind.owner,
            payment_method_type: onBehalf !== undefined && onBehalfEmail !== undefined ? onBehalfPaymentMethod.id : "card",
            owner_id: onBehalf || user._id,
            "dog_show_registrations": regPayload
          }).then((response) => {
            // DO - changed condition
            if (response?.client_secret) {
              setStripeOptions({
                clientSecret: response.client_secret
              });

              // DO
              // save the payment intent id
              setPaymentIntentId(response.payment_intent_id);
            }

            if (response?.transaction_id) {
              setTransactionId(response.transaction_id);
            }
          }).catch((e: any) => {
            toast.show({
              title: "Event Register",
              content: e.response?.data?.message ? e.response?.data?.message : "Something went wrong when attempting to register this user",
              duration: 10000,
              errorDetails: e,
              type: "fail"
            });
          });
        } else {
          if (event && onBehalf !== undefined && onBehalfEmail !== undefined) {
            apiService.createClubPaymentMethod(event.club_id).then((response) => {
              if (response && response.client_secret) {
                setStripeOptions({
                  clientSecret: response.client_secret
                });
              }
            });
          }
        }
      }
    }
  }, [currentStep, prevStep, regPayload, event, setStripeOptions, onBehalf, onBehalfEmail, onBehalfPaymentMethod, findFirstShowWithDogs, user._id]);

  useEffect(() => {
    if (currentStep === 4 && prevStep === 3 && stripeOptions === undefined /*&& clubPaymentMethods.length === 0*/) {
      if (event && onBehalf !== undefined && onBehalfEmail !== undefined) {
        apiService.createClubPaymentMethod(event.club_id).then((createResponse) => {
          if (createResponse && createResponse.client_secret) {
            setStripeOptions({
              clientSecret: createResponse.client_secret
            });
          }
        });
      }
    }
    // NOTE: reset the flag when picking dog for registration
    if (currentStep === 0) {
      setUsingTeamDogs(false);
    }
  }, [currentStep, prevStep, stripeOptions, setStripeOptions, setUsingTeamDogs, event, onBehalf, onBehalfEmail])

  // On Dog Details, Update Dollar Amount on Dog Details Change
  useEffect(() => {
    if (JSON.stringify(prevShows) !== JSON.stringify(shows)) {
      updatePaymentSummary();
    }
  }, [shows, prevShows, updatePaymentSummary]);

  const prevDogs = helperService.usePrevious(dogs);

  useEffect(() => {
    if (prevDogs !== dogs) {
      let _shows:IShowDogs[] = JSON.parse(JSON.stringify(shows));

      for (let s in _shows) {
        for (let d in _shows[s].dogs) {
          let findDog = dogs.filter((dog: IDogInfo) => dog._id === _shows[s].dogs[d]._id);

          if (findDog.length > 0) {
            _shows[s].dogs[d] = findDog[0];
          }
        }

        setShows(_shows);
      }
    }
  }, [prevDogs, dogs, setShows, shows]);

  // NOTE: init class for show types w/o any dog detail step inputs
  useEffect(() => {
    for (let s in shows) {
      const showType = shows[s].show_type;
      if (isNoQuestionsShow(showType)) {
        for (let d in shows[s].dogs) {
          const dog = shows[s].dogs[d];
          const classes: IDogClass[] = [{
            show_element: showType,
            level: showType,
          }];

          if (!dog.classes?.length) {
            updateDogInfoAllShowTypes(showType, classes, dog);
          }
        }
      }
    }
  }, [dogs, shows, showTypes])

  const getModalContent = () => {
    switch (modalContent) {
      case "dogForm":
        return <DogForm clubId={event?.club_id} onBehalf={onBehalf} onBehalfEmail={onBehalfEmail} onFinish={(dog: IDog) => {
          setModalContent("");
          toggle();
          handleDogUpdated();

          // NOTE: do not select dog for registration when adding team member for AKC
          if (!usingTeamDogs) {
            selectDog(currentShowTime, dog);
          }
        }}
      />;
    case "confirmRemoveCard":
      return <Confirm
        message={cardToDelete !== undefined ? <p>Are you sure you want to remove {cardToDelete.label}</p> : <></>}
        onConfirm={() => {
          if (event && cardToDelete) {
            apiService.deleteClubPaymentMethod(event.club_id, cardToDelete.id).then((response) => {
              apiService.getClubPaymentMethods(event.club_id).then((clubPaymentMethodsResponse) => {
                // setClubPaymentMethods(clubPaymentMethodsResponse);
                setStripeOptions(undefined);
              });

              setCardToDelete(undefined);
              toggle();
            });
          }
        }}
        onCancel={() => { toggle(); }}
      />
    }

    return (
      <div className="twoDogsInner">
        <div className="title">Registration</div>
        <div className="message">{twoDogMsg}</div>
        <div className="actions">
          <Button onClick={() => { setModalContent(""); toggle(); }}>Back</Button>
          <Button onClick={() => { setCurrentStep(currentStep + 1); setModalContent(""); toggle(); }}>Yes</Button>
        </div>
      </div>
    );
  }

  const validateChequeNumber = () => {
    if (onBehalfPaymentMethod.id === Constants.payment_method_type.cheque && !chequeNumber) {
      return { valid: false, message: "Please enter a cheque number" };
    }
    return { valid: true };
  }

  const registerOnBehalf = () => {
    if (event && regPayload && onBehalf && onBehalfEmail) {
      setLoadingBehalf(true);

      let validAddress:IAddressError = isValidAddress(userAddress);
      let validPhone:IAddressError = isValidPhone(userPhone);
      let validChequeNumber = validateChequeNumber();

      if (validAddress.valid && validPhone.valid && validChequeNumber.valid) {
        apiService.updateUserByClubManager(onBehalf, {
          address: userAddress,
          phone: userPhone
        }).then((userUpdateResponse) => {
          apiService.createRegistrationByClubManager(event._id, {
            registration_kind: Constants.registration_kind.club,
            //payment_method_id: clubPaymentMethods[selectedPaymentMethod].id,
            payment_method_type: onBehalfPaymentMethod.id,
            cheque_number: chequeNumber,
            "dog_show_registrations": regPayload,
            "owner_id": onBehalf
          }).then((response) => {
            navigate("/e/" + eid + "?dids=" + getDogIds() + "&redirect_status=succeeded&behalf=true");
          }).catch((e: any) => {
            toast.show({
              title: "Event Register",
              content: e.response?.data?.message ? e.response?.data?.message : "Something went wrong when attempting to register this user",
              duration: 10000,
              errorDetails: e,
              type: "fail"
            });
          }).finally(() => {
            setLoadingBehalf(false);
          });
        });
      } else {
        [validChequeNumber, validPhone, validAddress].filter((validator) => !validator.valid).forEach((validator) => {
          toast.show({
            title: "Event Register",
            content: validator.message ?? "",
            duration: 10000,
            type: "fail"
          });
        });
        setLoadingBehalf(false);
      }
    }
  }

  const pModalContent = helperService.usePrevious(modalContent);

  useEffect(() => {
    if (pModalContent !== modalContent) {
      if (modalContent !== "") {
        toggle();
      }
    } else {
      if (!isShown) {
        setModalContent("");
      }
    }
  }, [isShown, modalContent, pModalContent, setModalContent, toggle]);

  /*const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: paymentSummary.currency.toUpperCase() || "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });*/

  const getWaiverTitle = (sanctioningClub: string) => {
    switch (sanctioningClub) {
      case Constants.sanctioning_club.UKC:
        return "UKC Waiver";
      case Constants.sanctioning_club.ABI:
        return "ABI Waiver";
      case Constants.sanctioning_club.AKC:
        return "AKC Waiver";
      case Constants.sanctioning_club.PWDCA:
        return "Participation Agreement";
    }

    return "Waiver";
  }

  const getSignoffText = (sanctioningClub: string) =>
  {
    
    switch (sanctioningClub) {
      case Constants.sanctioning_club.AKC:
        if (onBehalf) 
          return user.display_name + " has received a signed copy of this waiver from the registrant."
        else
          return "I, "+ user.display_name +", have read and agree to the waiver on this page."
      case Constants.sanctioning_club.UKC:
        if (onBehalf) 
          return user.display_name + " has received a signed copy of this waiver from the registrant."
        else
          return "I, "+ user.display_name +", have read and agree to the waiver on this page. I swear that this dog is not being handled by a professional handler in Conformation."
      case Constants.sanctioning_club.ABI:
        if (onBehalf) 
          return user.display_name + " has received a signed copy of this waiver from the registrant."
        else
          return "I, "+ user.display_name +", have read and agree to the waiver on this page."
      case Constants.sanctioning_club.PWDCA:
        if (onBehalf)
          return user.display_name + " has received a signed copy of this waiver from the registrant."
        else
          return "I, "+ user.display_name +", have read and agree to the waiver on this page."
    }

    return "";
  }

  const getSignoffTextEventWaiver = () =>
  {
    if (onBehalf) 
      return user.display_name + " has received a signed copy of this waiver from the registrant."
    else
      return "I, "+ user.display_name +", have read and agree to the waiver on this page."
  }

  const getArbitrationAddress = () => {
    if (!event.arbitration_address) return "";

    const { city, state } = event.arbitration_address;
    return [city, state].join(", ");
  }

  const getWaiverText = (sanctioningClub: string) => {
    switch (sanctioningClub) {
      case Constants.sanctioning_club.UKC:
        return <>
          <p>All events are held under the Official Rules and Regulations of the United Kennel Club. Absolutely no illegal drugs or firearms will be allowed on the grounds or in the buildings on the day of a UKC Licensed event. UKC, its agents and employees, and the host club assume no responsibility for any loss, damage, or injury sustained by spectators or by exhibitors and handlers, or to any of their dogs or property, and further assume no responsibility for injury to children not under the control of their parents or guardians. </p>
          <p>UKC and the host club are not responsible for loss, accidents or theft. By signing this form, I hereby agree to release, waive, discharge and covenant not to sue UKC, its judges, officers, employee and agents and the host club from liability arising from  any claim, action, or lawsuit, including the negligence of the UKC, its judges, officers, employee and agents, and further agree to indemnify and hold UKC, the host club and any approved UKC Judge harmless from any claims, actions or lawsuits, including attorneys' fees, resulting from my participation in this event, and any action, decision or judgment made by any UKC or host club representative or approved Judge under the official UKC Rules and Regulations governing this event.</p>
          <p>I acknowledge that the current Official UKC Rules and Regulations (Agility, Conformation, Dock Jumping, Drag Racing,  Junior Showmanship, Lure Coursing, Obedience, Rally Obedience, Weight Pull, Precision Coursing, Nosework) have been made available to me, and that I am familiar with their contents.</p>
          <p><span>My signature indicates that I understand and agree to the above and to abide by all of the current Official UKC Rules and Regulations.</span> I have read this waiver of liability, assumption of risk, and indemnity agreement, fully understand its terms, and understand that I am giving up substantial rights, including my right to sue. I acknowledge that I am signing the agreement freely and voluntarily and intend by my signature to be a complete and unconditional release of all liability to the greatest extent allowed by law.</p>
        </>;
      case Constants.sanctioning_club.ABI:
        return <>
          <p>I (we) acknowledge that the Rules and Regulations of All Breed International Dog Shows (ABIDS) have been made available to me (us) on the website, and that I am (we are) familiar with the contents. I (we) agree that All Breed International Dog Shows (ABIDS) has the right to refuse this entry for cause, which the club shall deem to be sufficient. In consideration of the acceptance of this entry and of the holding of the show  and the  opportunity to have the dog judged and to win prize, ribbons or trophies, I (we) agree to hold All Breed International Dog Shows, Inc., their members, directors, governors, officers, agents, superintendents. show secretary or ring stewards and the owner or lessor of the premises and any employees of the aforementioned parties, harmless from any claim for loss or injury which may be alleged to have been caused directly or indirectly to any person or thing by the act of a dog while in or upon the show premises or grounds or near any entrance thereto, and I (we) personally assume all responsibility and liability for any such claim, and I (we) further agree to hold the aforementioned parties harmless from any claim for loss of a dog by disappearance, theft, death, or otherwise, and from any claim for damage or injury to the dog, whether such loss, disappearance, theft damage or injury, be caused or alleged to be caused by the negligence of All Breed International Dog Shows (ABIDS) or any of the parties aforementioned, or by the negligence of any other person, or any other cause or causes.</p>
          <p>I (we) hereby assume the sole responsibility for and to indemnify and save the aforementioned parties harmless from any and all loss and expenses (including legal fees) by reason of the liability imposed by law upon any of the aforementioned parties for damage because of bodily injuries, including death at any time resulting there from, sustained by any person or persons, including myself (ourselves), or on account of damage to property, arising out of or in consequence of my (our) participation in this show, howsoever such injuries, death or damage to property may be caused and whether or not the same may have been caused or may be alleged to have been caused by negligence of the aforementioned parties or any of their employees or agents, or any other persons.</p>
          <p>Judges may not judge dogs owned or co- owned by them.</p>
          <p>Entry fees will not be refunded in the event that a dog is, disqualified, or barred from competition by action of the Show Chairman or Show Secretary. All Breed International Dog Shows (ABIDS) reserves the right to refuse entries. Poor sportsmanship will not be tolerated at shows. If entered/paid and you are not able to attend the show monies will not be refunded to you & monies may not be put towards another show. If because of riots, civil disturbances or other acts beyond control of the management it is impossible to open or to complete the show, no entry fees will be refunded. Payment must be done by electronic transfer to dogsatoxford@gmail.com (Oxford Dog Sports) prior to the start of judging.</p>
          <p>Best of Breed Class:  Best of Breed competition is only for dogs that are ABIDS & FCI Champions a copy of FCI Championship must accompany your Entry Form. If according to owners or agents records your dog has completed the requirements for ABIDS Championship but Championship has not yet been confirmed by ABIDS office yet your win may be forfeited if no ABIDS Championship is actually acquired.</p>
        </>;
      case Constants.sanctioning_club.AKC:
        return <>
          <p>I (we) agree that the club holding this event has the right to refuse this entry for cause which the club shall deem sufficient.</p>
          <p>In consideration of the acceptance of this entry and of the holding of this event and of the opportunity to have the dog judged and to win prizes, ribbons, or trophies, I (we) agree to hold the AKC, the event-giving club, their members, directors, governors, officers, agents, superintendents or event secretary and the owner and/or lessor of the premises and any provider of services that are necessary to hold this event and any employees or volunteers of the aforementioned parties, and any AKC approved judge, judging at this event, harmless from any claim for loss or injury which may be alleged to have been caused directly or indirectly to any person or thing by the act of this dog while in or about the event premises or grounds or near any entrance thereto, and I (we) personally assume all responsibility and liability for any such claim; and I (we) further agree to hold the aforementioned parties harmless from any claim for loss, injury or damage to this dog.</p>
          <p>Additionally, I (we) hereby assume the sole responsibility for and agree to indemnify, defend and save the aforementioned parties harmless from any and all loss and expense (including legal fees) by reason of the liability imposed by law upon any of the aforementioned parties for damage because of bodily injuries, including death at any time resulting therefrom, sustained by any person or persons, including myself (ourselves), or on account of damage to property, arising out of or in consequence of my (our) participation in this event, however such, injuries, death or property damage may be caused, and whether or not the same may have been caused or may be alleged to have been caused by the negligence of the aforementioned parties or any of their employees, agents, or any other persons.</p>
          <p>I (WE) AGREE THAT ANY CAUSE OF ACTION, CONTROVERSY OR CLAIM ARISING OUT OF OR RELATED TO THE ENTRY, EXHIBITION OR ATTENDANCE AT THE EVENT BETWEEN THE AKC AND THE EVENT-GIVING CLUB (UNLESS OTHERWISE STATED IN ITS PREMIUM LIST) AND MYSELF (OURSELVES) OR AS TO THE CONSTRUCTION, INTERPRETATION AND EFFECT OF THIS AGREEMENT SHALL BE SETTLED BY ARBITRATION PURSUANT TO THE APPLICABLE RULES OF THE AMERICAN ARBITRATION ASSOCIATION. HOWEVER, PRIOR TO ARBITRATION ALL APPLICABLE AKC BYLAWS, RULES, REGULATIONS AND PROCEDURES MUST FIRST BE FOLLOWED AS SET FORTH IN THE AKC CHARTER AND BYLAWS, RULES, REGULATIONS, PUBLISHED POLICIES AND GUIDELINES.</p>
        </>;
      case Constants.sanctioning_club.PWDCA:
        return <>
          <p><span>Please sign this Participation Agreement to complete your Entry, Match registration and/or Trial Volunteer signup form.</span>
          </p>
          <p><span><b>Conditions:</b></span><span>&nbsp;These trials are open to purebred Portuguese Water Dogs. I/ we understand that the dogs must be in good health, proper fitness and condition for the test they are about to enter and must be at least 6 months of age in order to compete in the water trials. I/we agree to these terms. I/we accept full responsibility for the care of my dog(s) during the water trial.</span>
          </p>
          <p><span><b>Special Rules:</b></span><span>&nbsp;The water trial is located within the confines of {event.address.line1}. I/we agree to become familiar with and adhere to all site rules and regulations including but not limited to the following:</span>
          </p>
          <ul>
            <li><span>Dogs must be on leash or confined to a crate at all times except when participating in practice sessions or when actually being judged.</span>
            </li>
            <li><span>If my dog soils the grounds, I am responsible for cleanup and disposal.</span>
            </li>
            <li><span>Nothing (dogs, banners, etc.) is to be attached to any tree in the park.</span>
            </li>
          </ul>
          <p><span><b>General Rules:</b></span><span>&nbsp;The Portuguese Water Dog Club of America, Inc., (hereinafter “PWDCA”) rules, regulations, policies and guidelines for water trial participants (hereinafter “the rules”) are in the current PWDCA Water Trial Manual available on the Web site, </span><span><a href="https://www.google.com/url?q=http://www.pwdca.org/&amp;sa=D&amp;source=editors&amp;ust=1741170302741104&amp;usg=AOvVaw3ScQD_jqXIDIVrhN2DqDjJ">http://www.pwdca.org/</a></span><span>. I/we have received the current Manual and/or have read the rules via the Web site and I/we agree to obey the rules.</span>
          </p>
          <p><span><b>Hold-harmless:</b></span><span>&nbsp;I/we agree to hold the PWDCA and the event-giving club, their members, directors, officers, agents, and judge(s) at this event, the owner and/or lessor of the premises, any provider of services for this event and any employees or volunteers of any of the aforementioned parties, harmless from any claim for loss, injury, or illness which may be alleged to have been caused directly or indirectly to any person, animal or thing by the act of my dog while in or upon the trial grounds or while entering or leaving same, and I/we further agree to hold the aforementioned parties harmless from any claim for loss, disappearance or theft of, or damage injury or illness to myself, or my dog, whether such loss, disappearance, theft, damage, injury or illness is caused or alleged to be caused by the negligence of the club or any other parties aforementioned, by the negligence of any other person, or by any other cause or causes.</span></p>
          
          <p><span><b>Indemnification:</b></span><span>&nbsp;I/we hereby assume the sole responsibility for and agree to indemnify and save the aforementioned parties harmless from any and all loss and expense (including legal fees) by reason of the liability imposed by law upon any of the aforementioned parties for damage because of bodily injuries, including death at any time resulting there from, sustained by any person or persons, including myself (ourselves) or on account of damage to property, arising out of or in consequence of my (our) participation in this water trial, howsoever such same may have been caused or may be alleged to have been caused by negligence of the aforementioned parties or any of their employees or agents, or any other persons.</span></p>
           
          <p><span><b>Arbitration:</b></span><span>&nbsp;Notwithstanding any of the above, in the event that I/we or my dog(s) suffer any damage, injury, illness, or loss (including the death of the dog(s) arising from the water trial), I/we agree that any claim arising out of or related to the entry, exhibition or attendance at the event or as to the construction, interpretation and effect of this agreement shall be settled by arbitration pursuant to the applicable rules of the American</span></p>
          <p><span><b>Arbitration Association:</b> I/we agree that any such arbitration will take place in {getArbitrationAddress()} within 60 days of the incident giving rise to the claim, or at such other time and place as the parties may agree. I/we agree to pay a prorated share of the costs of any such arbitration.</span></p>
          
          <p><span>I/we agree that these clubs have the right to refuse this entry or any entry for any cause which they deem to be sufficient.</span></p>
          <p><span>I hereby certify I am the actual owner of the dog or duly authorized agent of or handler for the actual owner whose name has been entered above. I have read and agree to be bound by the agreement above as well as the stipulations contained in the premium list plus any directive received from any official involved in staging the event. I certify and represent that the dog entered is over 6 months of age (at the time of this event) and is not a hazard to persons or other dogs.</span></p>
          <p><span>*If the handler and/or substitute steward named herein is under 18 years of age (must be at least 9 or older), this entry form must be signed and acknowledged by his/her legal guardian. Parent or legal guardian must accompany the minor and remain on site during the event.</span></p>
        </>;
    }

    return <></>;
  }

  const isJoinedShow = (_sanc: string, _type: string) => {
    if (_sanc === Constants.sanctioning_club.UKC) {
      let nonJoinedShowTypes: string[] = [
        Constants.show_type.nosework,
        Constants.show_type.precision_coursing,
        Constants.show_type.dock_jumping
      ];

      if (!nonJoinedShowTypes.includes(_type)) {
        return true;
      }
    }

    if (_sanc === Constants.sanctioning_club.AKC) {
      let nonJoinedShowTypes: string[] = [
        Constants.show_type.conformation,
        Constants.show_type.rally_obedience,
        Constants.show_type.obedience,
        Constants.show_type.nosework,
        Constants.show_type.fast_cat,
        Constants.show_type.scentwork,
        Constants.show_type.fetch,
        Constants.show_type.farm_dog,
        Constants.show_type.att,
        Constants.show_type.canine_good_citizen
      ];

      if (!nonJoinedShowTypes.includes(_type)) {
        return true;
      }
    }

    if (_sanc === Constants.sanctioning_club.ABI) {
      let nonJoinedShowTypes:string[] = [
        Constants.show_type.urban_rat_race,
        Constants.show_type.scentwork,
        Constants.show_type.conformation
      ];

      if (!nonJoinedShowTypes.includes(_type)) {
        return true;
      }
    }

    if (_sanc === Constants.sanctioning_club.PWDCA) {
      let nonJoinedShowTypes:string[] = [
        Constants.show_type.water_dog,
      ];

      if (!nonJoinedShowTypes.includes(_type)) {
        return true;
      }
    }

    return false;
  }

  // NOTE: show type w/o any dog details to input (handler, levels etc.)
  const isNoQuestionsShow = (showType: string) => {
    return [
      Constants.show_type.farm_dog,
      Constants.show_type.att,
    ].includes(showType);
  }

  const handlerEnabled:string[] = [
    Constants.show_type.conformation,
    Constants.show_type.obedience,
    Constants.show_type.rally_obedience,
    Constants.show_type.fetch,
    Constants.show_type.fast_cat,
    Constants.show_type.water_dog,
  ];

  const getStepHint = () => {
    switch (currentStep) {
      case 0:
        return <>
          <p>Select all dogs you wish to enter into all trials. Expand each show type to display the list of trials for that show type. Select dogs you've already added to your account for each trial or add a new dog to your account by selecting "New Dog". Need more help? Try our <span onClick={() => { setJoyrideRun(true); }}>guided tour</span>.</p>
        </>;
      case 1:
        return <></>;
      default:
        return <></>;
    }
  }

  const setFirstShowTime = (index: number) => {
    let hasShowTypeShows = shows.filter((s: any) => { return s.show_type === showTypes[index]; });

    if (hasShowTypeShows.length > 0) {
      let i = shows.indexOf(hasShowTypeShows[0]);
      setCurrentShowTime(i);
    }
  }

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { action, index, type } = data;

    if (type === EVENTS.TARGET_NOT_FOUND) {
      setCurrentShow(0);
      setFirstShowTime(0);
    } else if (type === EVENTS.TOUR_END) {
      setJoyrideRun(false);
    }

    if ((action === ACTIONS.NEXT || action === ACTIONS.PREV) && type === EVENTS.STEP_AFTER) {
      setJoyrideStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if (action === ACTIONS.CLOSE) {
      setJoyrideRun(false);
    } else if (action === ACTIONS.START) {
      setJoyrideStepIndex(0);
    }
  };

  const getJudgeDislcaimer = (_show: IShow) => {
    let disclaimer:string = "";

    if (_show.breed_group_judges && _show.breed_group_judges.length > 0) {
      disclaimer += "Breed Group Judges: ";

      for (let i in _show.breed_group_judges) {
        let judge = _show.breed_group_judges[i];

        disclaimer += judge.judge_name + " (" + judge.breed_group + ")";

        if (Number(i) < _show.breed_group_judges.length - 1) {
          disclaimer += ", ";
        }
      }

      disclaimer += " ";
    }

    if (_show.breed_judges && _show.breed_judges.length > 0) {
      disclaimer += "Breed Specific Judges: ";

      for (let i in _show.breed_judges) {
        let judge = _show.breed_judges[i];

        disclaimer += judge.judge_name + " (" + judge.breed + ")";

        if (Number(i) < _show.breed_judges.length - 1) {
          disclaimer += ", ";
        }
      }
    }

    return disclaimer;
  }

  const getWaitlistStatus = (_showId: string, _dogId: string) => {
    for (let d in paymentSummary.details) {
      let _show:any = paymentSummary.details[d];

      if (_show.show_id === _showId) {
        for (let d in _show.dogs) {
          let _dog:any = _show.dogs[d];

          if (_dog.dog_id === _dogId) {
            for (let s in _dog.show_elements) {
              if (_dog.show_elements[s].waitlist === true) {
                return true;
              }
            }
          }
        }
      }
    }

    return false;
  }

  const getWaitlistText = (_showId: string, _dogId: string, _showType?: string) => {
    let _text:string = "";

    for (let d in paymentSummary.details) {
      let _show:any = paymentSummary.details[d];

      if (_show.show_id === _showId) {
        for (let d in _show.dogs) {
          let _dog:any = _show.dogs[d];
          
          if (_dog.dog_id === _dogId) {
            for (let s in _dog.show_elements) {
              if (_dog.show_elements[s].waitlist === true) {
                _text += _dog.show_elements[s].show_element;

                if (_dog.show_elements[s].level) {
                  _text += " - " + _dog.show_elements[s].level;
                }

                _text += ", ";
              }
            }
          }
        }
    }
    }

    _text = _text.slice(0, _text.length - 2);

    return _text;
  }

  const getPrecisionCourseName = (show: any) => {
    if (show.show_type === Constants.show_type.precision_coursing) {
      let hasDash = show.show_elements.filter((s: any) => { return s.level === Constants.dog_class_element_level.dash });
      let hasSteeplechase = show.show_elements.filter((s: any) => { return s.level === Constants.dog_class_element_level.steeplechase });

      if (hasDash.length !== 0 && hasSteeplechase.length === 0) {
        return " ("+ Constants.dog_class_element_level.dash +")";
      }

      if (hasDash.length === 0 && hasSteeplechase.length !== 0) {
        return " ("+ Constants.dog_class_element_level.steeplechase +")";
      }
    }

    return "";
  }

  const checkIfWaitlist = () => {
    if (paymentSummary) {
      for (let d in paymentSummary.details) {
        for (let dog in paymentSummary.details[d].dogs) {
          let _dog:any = paymentSummary.details[d].dogs[dog];
          for (let _se in _dog.show_elements) {
            if (_dog.show_elements[_se].waitlist && _dog.show_elements[_se].waitlist === true) {
              return "true";
            }
          }
        }
      }
    }

    return "false";
  }

  const registerForFree = () => {
    if (transactionId !== undefined && event?._id) {
      apiService.processOwnerRegistrationTransaction(event?._id, transactionId).then((response) => {
        navigate("/e/" + eid + "?dids=" + getDogIds() + "&redirect_status=succeeded&waitlist=" + checkIfWaitlist());
      }).catch((e: any) => {
        toast.show({
          title: "Event Register",
          content: e.response?.data?.message ? e.response?.data?.message : "Something went wrong. Please try again later.",
          duration: 10000,
          errorDetails: e,
          type: "fail"
        });
      });
    } else {
      toast.show({
        title: "Event Register",
        content: "Something went wrong. Please try again later.",
        duration: 10000,
        type: "fail"
      });
    }
  }

  return (
    <div className="EventRegister">
      {event && <Helmet>
        <title>{event?.title} Event - Register</title>
        <meta name="description" content={"Register for " + event?.title + " event on " + moment(event?.start_date).format('dddd MMMM Do, yyyy') + "."} />
        <meta name="robots" content="index, follow" />
      </Helmet>}
      <Joyride
        continuous={true}
        steps={joyrideSteps}
        callback={handleJoyrideCallback}
        stepIndex={joyrideStepIndex}
        run={joyrideRun}
        locale={{last: "Finish"}}
      />
      <div className={currentStep === 4 ? "registerWrap payNow" : "registerWrap"}>
        <div className={currentStep === 0 ? "registerInner noCart" : "registerInner"}>
          <div className="breadcrumb">{event?.title && <div className="path"><Link to={"/e/" + eid}>{event?.title}</Link> /</div>}<div className="current">Register</div></div>
          {onBehalf && onBehalfEmail && currentStep !== 4 && <div className="onBehalfMsg">
            <div className="msg">You're registering on behalf of <span>{onBehalfEmail}</span>.
              {(!isClaimed) && <div className="accountStatus"> This email doesn't have an active Eagerdog account, dogs on this account are managed by you.</div>}
              {(isClaimed) && <div className="accountStatus"> This email has an active Eagerdog account, displaying dogs created by both the user and you.</div>}
            </div>
          </div>}
          <div className="stepWrap">
            <ul className="steps">
              {steps.map((step:string, i:number) => {
                return(<li key={i} className={i === currentStep ? "active": i < currentStep ? "done" : ""}><span>{i + 1}</span><span>{step}</span></li>);
              })}
              <li className="actions">
                {(currentStep < steps.length - 1) && <button onClick={() => { next(); }}>Next</button>}
              </li>
            </ul>
            <div className="stepHint">{getStepHint()}</div>
            <div className="step">
              {loaded && currentStep === 0 && <div className="stepInner selectShows">
                {showTypes.map((showType:string, showTypeIndex:number) => {
                  return(
                    <div key={showTypeIndex} className={currentShow === showTypeIndex ? "showType expanded" : "showType"}>
                      <div onClick={() => { setCurrentShow(currentShow === showTypeIndex ? -1 : showTypeIndex); setFirstShowTime(showTypeIndex); }} className="title">
                        <div className="name">{showType}</div>
                        <div className="actions"><span className="hint">{currentShow === showTypeIndex ? "Collapse" : "Expand"}</span><div className="icon caretDown"></div></div>
                      </div>
                      <div className="showTimes">
                        {shows.map((show:IShowDogs, showIndex:number) => {
                          if (show.show_type === showType) {
                            return(
                              <ShowTime
                                key={showIndex}
                                className={currentShowTime === showIndex ? "expanded" : ""}
                                show={show}
                                onToggleShow={() => { setCurrentShowTime(currentShowTime === showIndex ? -1 : showIndex); }}
                                onAddDog={() => { setModalContent("dogForm"); }}
                                onEditDog={() => {
                                  handleDogUpdated();
                                }}
                                onDogClick={(dog: IDog) => { selectDog(showIndex, dog) }}
                                dogs={dogs}
                                onBehalf={onBehalf !== undefined && onBehalfEmail !== undefined}
                                isClaimed={isClaimed}
                              />
                            );
                          } else {
                            return(null);
                          }
                        })}
                      </div>
                    </div>
                  );
                })}
              </div>}
              {loaded && currentStep === 1 && <div className="stepInner dogDetails">
                {showTypes.map((showType:string, showTypeIndex:number) => {
                  if (showTypeHasDogs(showType) > 0) {
                    return(
                      <div key={showTypeIndex} className={currentShow === showTypeIndex ? "showType expanded" : "showType"}>
                        <div onClick={() => { setCurrentShow(currentShow === showTypeIndex ? 0 : showTypeIndex); }} className="title">
                          <div className="name">{showType}</div>
                          <div className="actions"><span className="hint">{currentShow === showTypeIndex ? "Collapse" : "Expand"}</span><div className="icon caretDown"></div></div>
                        </div>
                        {event && isJoinedShow(event.sanctioning_club, showType) && dogs.map((dog:any, dogIndex:number) => {
                          if (dogInShowType(dog, showType)) {
                            let _show = getJoinedShow(dog, showType);
                            let _dog = _show.dogs.filter((d: IDog) => { return d._id === dog._id; }).length > 0 ? _show.dogs.filter((d: IDog) => { return d._id === dog._id; })[0] : undefined;

                            return(
                              <div key={dogIndex} className="show">
                                <div key={dogIndex} className="dog">
                                  <div className="dogDetails">
                                    <DogPortrait dog={dog} />
                                    {getWaitlistStatus(_show._id, dog._id) && <><div className="waitlistTag">Waitlisted</div></>}
                                  </div>
                                  <div className="dogShowForm">
                                    {event && event.sanctioning_club === Constants.sanctioning_club.AKC && handlerEnabled.includes(showType) && _dog !== undefined &&
                                      <div className="earnTitleWrap">
                                        <Checkbox id={"usingAgent"+dog.call_name+_show._id} onChange={(e) => { toggleUsingAgentJoined(shows, _dog, showType); }} value={_dog.using_agent ? _dog.using_agent : false} label={"I'm using an agent handler for " + dog.call_name} />
                                      </div>
                                    }
                                    {_dog && _dog.using_agent &&
                                      <>
                                        <div className="agent">
                                          <Input required onChange={(e) => { updateAgentJoined(shows, _dog, showType, { name: e.target.value }); }} type="text" label="Agent/Handler Name" defaultValue={_dog.agent_name} placeholder="Enter your agent handler name" />
                                        </div>
                                        <div className="agent">
                                          <Input required onChange={(e) => { updateAgentJoined(shows, _dog, showType, { number: e.target.value }); }} type="text" label="Agent/Handler Number" defaultValue={_dog.agent_number} placeholder="Enter your agent handler number" />
                                        </div>
                                      </>
                                    }
                                    <FormBuilder
                                      isJunior={onBehalfJunior !== undefined ? onBehalfJunior === "true" : user.is_junior}
                                      event={event}
                                      show={_show}
                                      dog={dog}
                                      classes={_show.dogs.filter((d: IDogInfo) => d._id === dog._id)[0]?.classes || []}
                                      onChange={(classes: IDogClass[]) => {
                                        updateDogInfoAllShowTypes(_show.show_type, classes, dog);
                                      }}
                                      userDogs={dogs.filter((d) => d._id !== dog._id)}
                                      showDogs={shows[currentShow]}
                                      onAddDog={() => {
                                        setUsingTeamDogs(true);
                                        setModalContent("dogForm");
                                      }}
                                      onEditDog={(dog) => {
                                        handleDogUpdated();
                                        // NOTE: do not select dog for registration when adding team member for AKC
                                        if (!usingTeamDogs) {
                                          selectDog(currentShowTime, dog);
                                        }
                                      }}
                                    />
                                  <div className="judgeDisclaimer">{getJudgeDislcaimer(_show)}</div>
                                  {getWaitlistStatus(_show._id, dog._id) && <div className="waitlistWarning">One or more show level is currently at maximum capacity. {dog.call_name} will be placed on a waitlist for these shows ({getWaitlistText(_show._id, dog._id)}).</div>}
                                  </div>
                                </div>
                              </div>
                            );
                          } else {
                            return(null);
                          }
                        })}
                        {event && !isJoinedShow(event.sanctioning_club, showType) && shows.map((show:IShowDogs, showIndex:number) => {
                          if (show.dogs.length > 0 && show.show_type === showType) {
                            const timeZoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
                            
                            return(
                              <div key={showIndex} className="show">
                                <div className="title">{show.show_name} {getPrecisionCourseName(show)}</div>
                                <span className="time">{moment(show.show_date).tz(timeZoneString).format("dddd MMMM Do, YYYY @ h:mm A zz")}</span>
                                <div className="dogList">
                                  {show.dogs.map((dog:IDogInfo, dogIndex:number) => {
                                    return(<div key={dogIndex} className="dog">
                                      <div className="dogDetails">
                                        <DogPortrait dog={dog} />
                                        {getWaitlistStatus(show._id, dog._id) && <><div className="waitlistTag">Waitlisted</div></>}
                                      </div>
                                      <div className="dogShowForm">
                                        {isNoQuestionsShow(showType) && <p>No additional information required</p>}
                                        {((showType === Constants.show_type.fast_cat) || (dog.plan_to_earn_title) || (event && [Constants.sanctioning_club.AKC, Constants.sanctioning_club.PWDCA].includes(event.sanctioning_club) && handlerEnabled.includes(showType) && !!dog) || (dog && dog.using_agent)) && <div className="earnTitleWrap">
                                          {showType === Constants.show_type.fast_cat &&
                                            <div className="earnTitleInner">
                                              <Checkbox id={"earnTitle"+dog.call_name+show._id} onChange={(e) => { toggleEarnTitle(shows, dogIndex, showIndex); }} value={dog.plan_to_earn_title ? dog.plan_to_earn_title : false} label={dog.call_name + " is Planning to Earn a Title"} />        
                                            </div>
                                          }
                                          {dog.plan_to_earn_title &&
                                            <Dropdown className="titleDrop" value={title} label={"Title"} onChange={(e, value: IOption) => { updateTitle(shows, dogIndex, value, showIndex, undefined); }} options={akcTitles} placeholder="" />
                                          }
                                          {event && [Constants.sanctioning_club.AKC, Constants.sanctioning_club.PWDCA].includes(event.sanctioning_club) && handlerEnabled.includes(showType) && !!dog &&
                                            <div className="earnTitleWrap">
                                              <Checkbox disabled={dog.using_non_agent}  id={"usingAgent"+dog.call_name+show._id} onChange={(e) => { toggleUsingAgentSingle(showIndex, dogIndex); }} value={dog.using_agent ? dog.using_agent : false} label={"I'm using an agent handler for " + dog.call_name} />
                                            </div>
                                          }
                                          {dog && dog.using_agent &&
                                            <>
                                              <div className="agent">
                                                <Input required onChange={(e) => { updateAgentSingle(showIndex, dogIndex, { name: e.target.value }); }} type="text" label="Agent/Handler Name" defaultValue={dog.agent_name} placeholder="Enter your agent/handler name" />
                                              </div>
                                              <div className="agent">
                                                <Input required onChange={(e) => { updateAgentSingle(showIndex, dogIndex, { number: e.target.value }); }} type="text" label="Agent/Handler Number" defaultValue={dog.agent_number} placeholder="Enter your agent/handler number" />
                                              </div>
                                              {/* NOTE: PWDCA Water dog specific agent inputs */}
                                              {event && event.sanctioning_club === Constants.sanctioning_club.PWDCA && dog && dog.using_agent && <>
                                                <div className="agent">
                                                  <Input required onChange={(e) => { updateAgentJoined(shows, dog, showType, { email: e.target.value }); }} type="text" icon={emailIcon} label="Agent Email" placeholder="Agent Email" />
                                                </div>
                                                <div className="agent">
                                                  <Phone required onChange={(value: string) => { updateAgentJoined(shows, dog, showType, { phone: value }); }} value={dog.agent_phone} label="Agent Phone Number" />
                                                </div>
                                              </>}
                                            </>
                                          }
                                          {dog && event?.sanctioning_club === Constants.sanctioning_club.AKC && showType === Constants.show_type.conformation &&
                                            <div className="agent">
                                              <Checkbox disabled={dog.using_agent} id={"usingNonAgent"+dog.call_name+show._id} onChange={() => { toggleUsingNonAgentSignle(showIndex, dogIndex, !dog.using_non_agent); }} value={dog.using_non_agent ?? false} label={"I'm using a non-agent handler for " + dog.call_name} />
                                            </div>
                                          }
                                        </div>}
                                        {/* NOTE: PWDCA Water dog substitute mandatory information */}
                                        {event && event.sanctioning_club === Constants.sanctioning_club.PWDCA && dog && <>
                                          <div className="substituteWrapper">
                                            <div className="substituteTitle">Substitute information</div>
                                            <div className="agent">
                                              <Input required onChange={(e) => { updateSubstituteJoined(shows, dog, showType, { name: e.target.value }); }} type="text" label="Substitue Steward Name" defaultValue={dog.substitute_name} placeholder="Substitue name" />
                                            </div>
                                            <div className="agent">
                                              <Input required onChange={(e) => { updateSubstituteJoined(shows, dog, showType, { email: e.target.value }); }} type="email" icon={emailIcon} label="Substitue Steward Email" defaultValue={dog.substitute_email} placeholder="Substitue Email" />
                                            </div>
                                            <div className="agent">
                                              <Phone required onChange={(value: string) => { updateSubstituteJoined(shows, dog, showType, { phone: value }); }} value={dog.substitute_phone} label="Substitue Steward Phone Number" />
                                            </div>
                                          </div>
                                        </>}
                                        <FormBuilder
                                          isJunior={onBehalfJunior !== undefined ? onBehalfJunior === "true" : user.is_junior}
                                          event={event ?? undefined}
                                          show={show}
                                          dog={dog}
                                          classes={dog.classes || []}
                                          onChange={(classes: IDogClass[]) => {
                                            updateDogInfo(showIndex, dogIndex, classes); }}
                                          userDogs={dogs.filter((d) => d._id !== dog._id)}
                                          showDogs={shows[currentShow]}
                                          onAddDog={() => {
                                            setUsingTeamDogs(true);
                                            setModalContent("dogForm");
                                          }}
                                          onEditDog={(dog) => {
                                            handleDogUpdated();
                                            // NOTE: do not select dog for registration when adding team member for AKC
                                            if (!usingTeamDogs) {
                                              selectDog(currentShowTime, dog);
                                            }
                                          }}
                                        />
                                        {/* NOTE: For PWDCA Water Dog show only if dog class selected */}
                                        {event && event.sanctioning_club === Constants.sanctioning_club.PWDCA && dog && !!dog.classes?.length &&
                                          [
                                            Constants.dog_class_element.working,
                                            Constants.dog_class_element.courier,
                                            Constants.dog_class_element.master
                                          ].includes(dog.classes?.[0]?.level) &&
                                            <Dropdown
                                              value={workingOrCourierOptions[0]}
                                              label="What leg are you working on?"
                                              onChange={(_e, option: IOption) => { updateDogLegInfo(shows, dog, showType, option.value); }}
                                              options={getWorkingLegOptions(dog.classes ?? [])}
                                              placeholder=""
                                            />
                                        }
                                        <div className="judgeDisclaimer">{getJudgeDislcaimer(show)}</div>
                                        {getWaitlistStatus(show._id, dog._id) && <div className="waitlistWarning">One or more show level is currently at maximum capacity. {dog.call_name} will be placed on a waitlist for these shows ({getWaitlistText(show._id, dog._id)}).</div>}
                                      </div>
                                    </div>);
                                  })}
                                </div>
                              </div>
                            );
                          } else {
                            return(null);
                          }
                        })}
                      </div>
                    );
                  } else {
                    return(null);
                  }
                })}
              </div>}
              {loaded && currentStep === 2 && <div className="stepInner waiver">
                <div className="waiverInner">
                  <div className="waiverTitle">{getWaiverTitle(event ? event.sanctioning_club : "")}</div>
                  {getWaiverText(event ? event.sanctioning_club : "")}
                </div>
                <div className="waiverSign">
                  <div className="checkContainer">
                    <Checkbox onChange={(e) => { setAgreeToWaiver(!agreeToWaiver); }} value={agreeToWaiver} id="waiverSign" label={getSignoffText(event ? event.sanctioning_club : "")} />
                  </div>
                  <div className="signature"></div>
                </div>
              </div>}
              {loaded && currentStep === 3 && <div className="stepInner eventWaiver">
                <div className="eventWaiverInner">
                  <div className="eventWaiverTitle">Event Waiver</div>
                  <div dangerouslySetInnerHTML={{__html:event.waiver}} />
                </div>
                <div className="eventWaiverSign">
                  <div className="checkContainer">
                    <Checkbox onChange={(e) => { setAgreeToEventWaiver(!agreeToEventWaiver); }} value={agreeToEventWaiver} id="waiverSign" label={getSignoffTextEventWaiver()}/>
                  </div>
                  <div className="signature"></div>
                </div>
              </div>}
              {loaded && currentStep === 4 && <div className="stepInner payment">
                <div className="paymentWrap">
                  {onBehalf !== undefined && onBehalfEmail !== undefined && stripeOptions !== undefined && stripePromise !== undefined && <div className="behalfWrap warning">
                    <div className="behalfWarning">
                      <div className="behalfIcon"><div className="icon alert"><span></span></div></div>
                      <div className="behalfMsg">You're registering on behalf of <span>{onBehalfEmail}</span>. {/*Fees (<span>{formatter.format(paymentSummary.fees || 0)}</span>) applied to the registration will be charged to your kennel club.*/}</div>
                    </div>
                  </div>}
                  <div className="title">Owner Information</div>
                  <UserAddress
                    onBehalf={onBehalf !== undefined && onBehalfEmail !== undefined ? true : false}
                    user={user}
                    onChange={(address: IAddress, phone: string) => {
                      setUserAddress(address);
                      setUserPhone(phone);
                    }
                  } />
                  {onBehalf === undefined && onBehalfEmail === undefined && stripeOptions !== undefined && stripePromise !== undefined &&
                    <Elements stripe={stripePromise} options={stripeOptions}>
                      <Checkout
                        redirect={Config.web.REACT_APP_WEB_URL + "/e/" + eid + "?dids=" + getDogIds() + "&waitlist=" + checkIfWaitlist() }
                        userAddress={userAddress}
                        userPhone={userPhone}
                      />
                    </Elements>
                  }
                  {onBehalf === undefined && onBehalfEmail === undefined && stripeOptions === undefined && transactionId !== undefined && <>
                    <div className="freeActions">
                      <Button onClick={() =>{ registerForFree(); }}>Register For Free </Button>
                    </div>
                  </>}
                  {onBehalf !== undefined && onBehalfEmail !== undefined && stripeOptions !== undefined && stripePromise !== undefined && <div className="behalfWrap">
                    {/*clubPaymentMethods.length > 0 && */<div className="clubHasCard">
                      <Dropdown value={onBehalfPaymentMethod} label={"Payment Method"} onChange={(e, value: IOption) => { setOnBehalfPaymentMethod(value); }} options={onBehalfPaymentMethods} placeholder="" />
                      {/*<div className="title">Payment Information</div>
                      <RadioList
                        list={clubPaymentMethods}
                        selected={selectedPaymentMethod}
                        onSelect={(index: number) => { setSelectedPaymentMethod(index); }}
                      />*/}
                      {onBehalfPaymentMethod.id === Constants.payment_method_type.cheque &&
                        <Input required label="Cheque Number" type="text" onChange={(e) => { e.stopPropagation(); setChequeNumber(e.target.value); }} defaultValue={chequeNumber} />
                      }
                      <div className="actions">
                        <Button isLoading={loadingBehalf} onClick={() => { registerOnBehalf(); }}>Register User</Button>
                      </div>
                    </div>}
                    {/*clubPaymentMethods.length === 0 && <>
                      <Elements stripe={stripePromise} options={stripeOptions}>
                        <Checkout
                          onBehalf={true}
                          onAddCard={() => {
                            if (event) {
                              getClubCards(event?.club_id);
                            }
                          }}
                          returnUrl={Config.web.REACT_APP_WEB_URL + "/e/" + eid + "/register"}
                          redirect={Config.web.REACT_APP_WEB_URL + "/e/" + eid + "?dids=" + getDogIds() }
                        />
                      </Elements>
                    </>*/}
                  </div>}
                </div>
              </div>}
            </div>
            <div className={currentStep === 0 ? "actions": "actions two"}>
              {currentStep !== 0 && currentStep !== 4 && <button onClick={() => { previous(); }}>Previous</button>}
              {(currentStep < steps.length - 1) && <button className="joy" onClick={() => { next(); }}>Next</button>}
            </div>
          </div>
        </div>
        {currentStep !== 0 && <Cart onApplyDiscount={currentStep === 4 ? (discount: string) => { updatePaymentSummary(discount)} : undefined } shows={shows} paymentSummary={paymentSummary} />}
      </div>
      <Modal
        className={modalContent}
        isShown={isShown}
        hide={toggle}
        modalContent={getModalContent()}
      />
    </div>
  );
};

export default EventRegister;